<template>
  <section class="footer">
    <div class="container">
      <table
        width="100%"
        border="0"
        cellspacing="0"
        cellpadding="0"
        class="footerbadges"
      >
        <tbody>
          <tr>
            <td rowspan="2" width="300">
              <img
                loading="lazy"
                :src="require('@/assets/images/footer-logo.png')"
                width="238"
                alt="Footer NSSI Logo"
              />
            </td>
          </tr>
          <tr>
            <td class="hidemobile">
              <div>
                <img
                  loading="lazy"
                  :src="require('@/assets/images/footer-icon3.svg')"
                  class="footericonfloat"
                  width="59"
                  height="50"
                  alt="Icon"
                />Excellent Customer Service
              </div>
            </td>
            <td class="hidemobile">
              <div>
                <img
                  loading="lazy"
                  :src="require('@/assets/images/footer-icon2.svg')"
                  class="footericonfloat"
                  width="59"
                  height="50"
                  alt="Icon"
                />Unsatisfied? Cancel Anytime.
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <br />

      <p class="helperlinks">
        <span
          ><router-link :to="{ name: 'quote' }">Get a Quote</router-link></span
        >
        <modal-links
          :modals="footerModals"
          style="display: inline !important; padding-left: 20px"
          title="footer"
        />
        <br />
      </p>

      <p>
        National Student Services Inc. has partnered with Assurant to offer
        Renters Insurance to college students. NSSI is the administrator of the
        accidental damage personal property coverage of this offer. Both
        policies are backed by A.M. Best "A" Rating underwriters. We are not
        responsible for Assurant coverage selections, policies issued, claims,
        the content or operation of others' websites, or how others handle or
        use your information. Information you provide to others is subject to
        their privacy policies and website terms of use. The producer will
        receive compensation from the insurance company for the sale of this
        insurance.
      </p>

      <p>
        National Student Services, Inc. has been family-owned and operated since
        1971. Based in Stillwater, Oklahoma, NSSI is a leader in providing
        college students with personal property accidental damage insurance. You
        can expect reliable insurance paired with exceptional customer service.
      </p>

      <p class="helperlinks">
        <a href="https://www.nssi.com/terms-of-use" target="_blank"
          >Terms of Use</a
        >
        <a href="https://www.nssi.com/privacy-policy" target="_blank"
          >Privacy Policy</a
        >
        <router-link :to="{ name: 'legalAssurant' }">
          Assurant Legal
        </router-link>
        <a href="https://www.nssi.com/unsubscribe" target="_blank"
          >Unsubscribe</a
        >
      </p>
      <br />

      <table
        width="100%"
        border="0"
        cellspacing="0"
        cellpadding="0"
        class="finalfooter"
      >
        <tbody>
          <tr>
            <td>
              © {{ getCurrentYear }} National Student Services, Inc. All Rights
              Reserved.
            </td>
            <td class="creditcards">
              <img
                loading="lazy"
                style="
                  max-width: 581px;
                  width: 100% !important;
                  height: auto !important;
                "
                :src="require('@/assets/images/creditcards.png')"
                alt="Credit Cards Accepted Payment Methods BBB A+ PCI"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script lang="ts" setup>
import ModalNames from "@/utils/ModalNames";
import { ref, computed, ComputedRef } from "vue";
import { ModalsArr } from "@/utils/ModalsArr";
import ModalLinks from "@/views/partials/ModalLinks.vue";
import { getCurrentYear } from "@/utils/Utils";

const footerModals = ModalsArr;

//TODO checks
const partnershipsModal = ref<InstanceType<
  typeof ModalNames.PARTNERSHIPS_MODAL
> | null>(null);
const contactNssiModal = ref<InstanceType<
  typeof ModalNames.CONTACT_MODAL
> | null>(null);

// const element = document.body.getElementsByClassName("modal hide");
// console.log(element);
const assurantBookletPath: ComputedRef<string> = computed(() => {
  return window.location.href + "assets/assurantpolicybooklet.pdf";
});
</script>
<style>
.helperlinks .mod {
  display: inline;
  padding-left: 10px;
}
</style>
